"use client"

import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { cn } from "../../lib/utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => (
<SwitchPrimitives.Root
  className={cn(
    "peer inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-green-500 data-[state=unchecked]:bg-gray-200",
    // Added more distinct colors for checked/unchecked states
    className
  )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
  className={cn(
    "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
    // Changed bg-background to bg-white for better contrast
  )}
/>
  </SwitchPrimitives.Root>
))
Switch.displayName = "Switch"

export { Switch }